import React from "react";
import DropDown from "./index";
import UnconfiguredComponent from "../common3/UnconfiguredComponent";

import isEmpty from "lodash/isEmpty";

const DropDownEdit = (props) => {
  const { extra = {}, builder = false } = props;
  const { options = null, optionsType } = extra;

  if (builder && optionsType === "static" && isEmpty(options)) {
    return <UnconfiguredComponent hint="Add options to component" />;
  }

  if (optionsType === "effects" || optionsType === "register") {
    return (
      <DropDown
        {...props}
        extra={{ ...props.extra, options: "test" }}
        effects={{
          ...props.effect,
          ...{
            [props.id]: [
              { label: "Dynamic Content #1", value: "dynamic1" },
              { label: "Dynamic Content #2", value: "dynamic1" },
              { label: "Dynamic Content #3", value: "dynamic1" },
            ],
          },
        }}
      />
    );
  }

  return <DropDown {...props} />;
};

export default DropDownEdit;
